import { Box } from '@mui/material'
import { COLORS } from 'styles/colors'
import SwitchiOS from 'ui/SwitchiOS'
import { TypographyPrimary } from './typography/TypographyPrimary'

interface SelectedInfoBlockProps {
	selectedCheckboxes: number[]
	resetCheckboxes: () => void
	showOnlySelected: boolean
	setShowOnlySelected: (val: boolean) => void
}

const SelectedInfoBlock = ({
	selectedCheckboxes,
	resetCheckboxes,
	showOnlySelected,
	setShowOnlySelected,
}: SelectedInfoBlockProps) => {
	return (
		<Box
			sx={{
				width: '1080px',
				height: '24px',
				display: 'flex',
				alignItems: 'center',
				gap: '16px',
				opacity: 1,
			}}
		>
			<TypographyPrimary>Выбрано {selectedCheckboxes.length}</TypographyPrimary>
			<TypographyPrimary
				sx={{ color: COLORS.blue, cursor: 'pointer' }}
				onClick={resetCheckboxes}
			>
				Сбросить
			</TypographyPrimary>
			<SwitchiOS
				checked={showOnlySelected}
				onClick={() => setShowOnlySelected(!showOnlySelected)}
				background={COLORS.success}
			/>
			<TypographyPrimary>Показать только выбранные</TypographyPrimary>
		</Box>
	)
}

export default SelectedInfoBlock
